import { memo } from 'react';
import { ReservationServiceResourceView } from 'models';
import { useTranslation } from 'react-i18next';
import { eventDuration } from 'utils';

import { BorderedBox } from 'components';
import Button from '@material-ui/core/Button';

import { useStyles } from './style';

interface Props {
  resource: ReservationServiceResourceView;
  serviceId: string | null;
  slotDuration: number | null;
  onOpen(
    resource: ReservationServiceResourceView,
    serviceId: string | null,
    slotDuration: number | null
  ): void;
}

const ReservationItem: React.FC<Props> = ({
  resource,
  slotDuration,
  serviceId,
  onOpen,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { SlotPrice, ImagesUrl, Name, Description } = resource;
  const imgSrc = ImagesUrl.length ? ImagesUrl[0] : null;
  const alt = Name || '';
  const price = SlotPrice?.Value
    ? ` ${eventDuration(slotDuration)} / ${SlotPrice?.Symbol} ${
        SlotPrice?.Value
      } `
    : t('Free');

  return (
    <BorderedBox className={classes.box}>
      <h5 className={classes.reservationTitle}>{resource.Name}</h5>
      <div className={classes.flex}>
        <div className={classes.imgWrapper}>
          {imgSrc ? (
            <img className={classes.img} src={imgSrc} alt={alt} />
          ) : null}
        </div>
        <div className={classes.contentWrapper}>
          <span className={classes.price}>{price}</span>
          <span className={classes.description}>{Description}</span>
          <Button
            classes={{ root: classes.button }}
            onClick={() => onOpen(resource, serviceId, slotDuration)}
          >
            {t('Kalenteri')}
          </Button>
        </div>
      </div>
    </BorderedBox>
  );
};

export default memo(ReservationItem);
